/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Authentication api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AdminManualRefund } from '../model';
// @ts-ignore
import { CreditRefundRequest } from '../model';
// @ts-ignore
import { ProcessUserRefundRequest } from '../model';
// @ts-ignore
import { RefundAsCreditRequest } from '../model';
// @ts-ignore
import { RefundAsCreditResponse } from '../model';
// @ts-ignore
import { RefundStatus } from '../model';
// @ts-ignore
import { RefundStatusResponse } from '../model';
// @ts-ignore
import { RefundWhoisResponse } from '../model';
// @ts-ignore
import { UserRefundOptionsResult } from '../model';
// @ts-ignore
import { UserRefundRequestViewPagedResponse } from '../model';
/**
 * UserRefundApiApiCreditRefundRequestPost - axios parameter creator
 * 
 * @summary current user requesting credit refund into his bank account (Auth)
 * @param {CreditRefundRequest} [creditRefundRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiCreditRefundRequestPostAxiosParamCreator (creditRefundRequest?: CreditRefundRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/CreditRefundRequest`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(creditRefundRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiOperatorUserRefundsGet - axios parameter creator
 * 
 * @summary  (Auth policies: auth:ProcessRefundRequest)
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {RefundStatus} [status] 
 * @param {string} [searchTerm] 
 * @param {boolean} [onlyManualRefunds] 
 * @param {number} [page] 
 * @param {number} [pageSize] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiOperatorUserRefundsGetAxiosParamCreator (from?: string, to?: string, status?: RefundStatus, searchTerm?: string, onlyManualRefunds?: boolean, page?: number, pageSize?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/operator/user/refunds`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['From'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['To'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }

    if (status !== undefined) {
        localVarQueryParameter['Status'] = status;
    }

    if (searchTerm !== undefined) {
        localVarQueryParameter['SearchTerm'] = searchTerm;
    }

    if (onlyManualRefunds !== undefined) {
        localVarQueryParameter['OnlyManualRefunds'] = onlyManualRefunds;
    }

    if (page !== undefined) {
        localVarQueryParameter['Page'] = page;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiRefundsAsCreditCancelRefundTokenPut - axios parameter creator
 * 
 * @summary  (Auth policies: auth:RefundAsCredit)
 * @param {number} refundToken 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiRefundsAsCreditCancelRefundTokenPutAxiosParamCreator (refundToken: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'refundToken' is not null or undefined
    assertParamExists('apiRefundsAsCreditCancelRefundTokenPut', 'refundToken', refundToken)
    const localVarPath = `/api/refunds/as-credit/cancel/{refundToken}`
        .replace(`{${"refundToken"}}`, encodeURIComponent(String(refundToken)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiRefundsAsCreditUserUserIdPost - axios parameter creator
 * 
 * @summary user can request his refund amount to be added as user credit in his account (Auth policies: auth:RefundAsCredit)
 * @param {number} userId 
 * @param {RefundAsCreditRequest} [refundAsCreditRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiRefundsAsCreditUserUserIdPostAxiosParamCreator (userId: number, refundAsCreditRequest?: RefundAsCreditRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiRefundsAsCreditUserUserIdPost', 'userId', userId)
    const localVarPath = `/api/refunds/as-credit/user/{userId}`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(refundAsCreditRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiRefundsCancelCreditRefundRefundIdDelete - axios parameter creator
 * 
 * @summary cancel request of credit refund by admin (Auth policies: auth:CancelCreditRefundRequest)
 * @param {number} refundId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiRefundsCancelCreditRefundRefundIdDeleteAxiosParamCreator (refundId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'refundId' is not null or undefined
    assertParamExists('apiRefundsCancelCreditRefundRefundIdDelete', 'refundId', refundId)
    const localVarPath = `/api/refunds/cancel-credit-refund/{refundId}`
        .replace(`{${"refundId"}}`, encodeURIComponent(String(refundId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiRefundsCreditRefundIdAcceptPost - axios parameter creator
 * 
 * @summary  (Auth)
 * @param {number} id 
 * @param {number} [userId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiRefundsCreditRefundIdAcceptPostAxiosParamCreator (id: number, userId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiRefundsCreditRefundIdAcceptPost', 'id', id)
    const localVarPath = `/api/refunds/credit-refund/{id}/accept`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiRefundsCreditRefundManualGet - axios parameter creator
 * 
 * @summary  (Auth)
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiRefundsCreditRefundManualGetAxiosParamCreator (from?: string, to?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/refunds/credit-refund/manual`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['From'] = (from as any instanceof Date) ?
            (from as any).toISOString().substr(0,10) :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['To'] = (to as any instanceof Date) ?
            (to as any).toISOString().substr(0,10) :
            to;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiRefundsCreditRefundPost - axios parameter creator
 * 
 * @summary current user requesting credit refund into his bank account (Auth)
 * @param {CreditRefundRequest} [creditRefundRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiRefundsCreditRefundPostAxiosParamCreator (creditRefundRequest?: CreditRefundRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/refunds/credit-refund`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(creditRefundRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiRefundsCreditRefundRefundIdRetryPatch - axios parameter creator
 * 
 * @summary retry request of credit refund by admin (Auth policies: auth:RetryCreditRefundRequest)
 * @param {number} refundId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiRefundsCreditRefundRefundIdRetryPatchAxiosParamCreator (refundId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'refundId' is not null or undefined
    assertParamExists('apiRefundsCreditRefundRefundIdRetryPatch', 'refundId', refundId)
    const localVarPath = `/api/refunds/credit-refund/{refundId}/retry`
        .replace(`{${"refundId"}}`, encodeURIComponent(String(refundId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiRefundsCreditRefundUpdateStatusesPost - axios parameter creator
 * 
 * @summary retry request of credit refund by admin (Auth policies: auth:GetRefundCreditStatus)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiRefundsCreditRefundUpdateStatusesPostAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/refunds/credit-refund/updateStatuses`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiRefundsCreditRefundWhoisIdDelete - axios parameter creator
 * 
 * @summary cancel request of credit refund by admin (Auth policies: auth:CancelCreditRefundRequest)
 * @param {number} whoisId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiRefundsCreditRefundWhoisIdDeleteAxiosParamCreator (whoisId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'whoisId' is not null or undefined
    assertParamExists('apiRefundsCreditRefundWhoisIdDelete', 'whoisId', whoisId)
    const localVarPath = `/api/refunds/credit-refund/{whoisId}`
        .replace(`{${"whoisId"}}`, encodeURIComponent(String(whoisId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiRefundsCreditRefundWhoisPost - axios parameter creator
 * 
 * @summary  (Auth)
 * @param {CreditRefundRequest} [creditRefundRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiRefundsCreditRefundWhoisPostAxiosParamCreator (creditRefundRequest?: CreditRefundRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/refunds/credit-refund/whois`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(creditRefundRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiRefundsProcessRefundRefundIdPost - axios parameter creator
 * 
 * @summary operator either approves or disapproves a refund request (Auth policies: auth:ProcessRefundRequest)
 * @param {number} refundId 
 * @param {ProcessUserRefundRequest} [processUserRefundRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiRefundsProcessRefundRefundIdPostAxiosParamCreator (refundId: number, processUserRefundRequest?: ProcessUserRefundRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'refundId' is not null or undefined
    assertParamExists('apiRefundsProcessRefundRefundIdPost', 'refundId', refundId)
    const localVarPath = `/api/refunds/process-refund/{refundId}`
        .replace(`{${"refundId"}}`, encodeURIComponent(String(refundId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(processUserRefundRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiRefundsStatusRefundIdGet - axios parameter creator
 * 
 * @summary  (Auth)
 * @param {number} refundId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiRefundsStatusRefundIdGetAxiosParamCreator (refundId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'refundId' is not null or undefined
    assertParamExists('apiRefundsStatusRefundIdGet', 'refundId', refundId)
    const localVarPath = `/api/refunds/status/{refundId}`
        .replace(`{${"refundId"}}`, encodeURIComponent(String(refundId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserRefundApiApiUserRefundOptionsGet - axios parameter creator
 * 
 * @summary  (Auth)
 * @param {number} [userId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserRefundApiApiUserRefundOptionsGetAxiosParamCreator (userId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/user/refund-options`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiCreditRefundRequestPost operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiCreditRefundRequestPostRequest
 */
export interface UserRefundApiApiCreditRefundRequestPostRequest {
    /**
     * 
     * @type {CreditRefundRequest}
     * @memberof UserRefundApiApiCreditRefundRequestPost
     */
    readonly creditRefundRequest?: CreditRefundRequest
}

/**
 * Request parameters for apiOperatorUserRefundsGet operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiOperatorUserRefundsGetRequest
 */
export interface UserRefundApiApiOperatorUserRefundsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserRefundApiApiOperatorUserRefundsGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof UserRefundApiApiOperatorUserRefundsGet
     */
    readonly to?: string

    /**
     * 
     * @type {RefundStatus}
     * @memberof UserRefundApiApiOperatorUserRefundsGet
     */
    readonly status?: RefundStatus

    /**
     * 
     * @type {string}
     * @memberof UserRefundApiApiOperatorUserRefundsGet
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {boolean}
     * @memberof UserRefundApiApiOperatorUserRefundsGet
     */
    readonly onlyManualRefunds?: boolean

    /**
     * 
     * @type {number}
     * @memberof UserRefundApiApiOperatorUserRefundsGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof UserRefundApiApiOperatorUserRefundsGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiRefundsAsCreditCancelRefundTokenPut operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiRefundsAsCreditCancelRefundTokenPutRequest
 */
export interface UserRefundApiApiRefundsAsCreditCancelRefundTokenPutRequest {
    /**
     * 
     * @type {number}
     * @memberof UserRefundApiApiRefundsAsCreditCancelRefundTokenPut
     */
    readonly refundToken: number
}

/**
 * Request parameters for apiRefundsAsCreditUserUserIdPost operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiRefundsAsCreditUserUserIdPostRequest
 */
export interface UserRefundApiApiRefundsAsCreditUserUserIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof UserRefundApiApiRefundsAsCreditUserUserIdPost
     */
    readonly userId: number

    /**
     * 
     * @type {RefundAsCreditRequest}
     * @memberof UserRefundApiApiRefundsAsCreditUserUserIdPost
     */
    readonly refundAsCreditRequest?: RefundAsCreditRequest
}

/**
 * Request parameters for apiRefundsCancelCreditRefundRefundIdDelete operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiRefundsCancelCreditRefundRefundIdDeleteRequest
 */
export interface UserRefundApiApiRefundsCancelCreditRefundRefundIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof UserRefundApiApiRefundsCancelCreditRefundRefundIdDelete
     */
    readonly refundId: number
}

/**
 * Request parameters for apiRefundsCreditRefundIdAcceptPost operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiRefundsCreditRefundIdAcceptPostRequest
 */
export interface UserRefundApiApiRefundsCreditRefundIdAcceptPostRequest {
    /**
     * 
     * @type {number}
     * @memberof UserRefundApiApiRefundsCreditRefundIdAcceptPost
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof UserRefundApiApiRefundsCreditRefundIdAcceptPost
     */
    readonly userId?: number
}

/**
 * Request parameters for apiRefundsCreditRefundManualGet operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiRefundsCreditRefundManualGetRequest
 */
export interface UserRefundApiApiRefundsCreditRefundManualGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserRefundApiApiRefundsCreditRefundManualGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof UserRefundApiApiRefundsCreditRefundManualGet
     */
    readonly to?: string
}

/**
 * Request parameters for apiRefundsCreditRefundPost operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiRefundsCreditRefundPostRequest
 */
export interface UserRefundApiApiRefundsCreditRefundPostRequest {
    /**
     * 
     * @type {CreditRefundRequest}
     * @memberof UserRefundApiApiRefundsCreditRefundPost
     */
    readonly creditRefundRequest?: CreditRefundRequest
}

/**
 * Request parameters for apiRefundsCreditRefundRefundIdRetryPatch operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiRefundsCreditRefundRefundIdRetryPatchRequest
 */
export interface UserRefundApiApiRefundsCreditRefundRefundIdRetryPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof UserRefundApiApiRefundsCreditRefundRefundIdRetryPatch
     */
    readonly refundId: number
}

/**
 * Request parameters for apiRefundsCreditRefundWhoisIdDelete operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiRefundsCreditRefundWhoisIdDeleteRequest
 */
export interface UserRefundApiApiRefundsCreditRefundWhoisIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof UserRefundApiApiRefundsCreditRefundWhoisIdDelete
     */
    readonly whoisId: number
}

/**
 * Request parameters for apiRefundsCreditRefundWhoisPost operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiRefundsCreditRefundWhoisPostRequest
 */
export interface UserRefundApiApiRefundsCreditRefundWhoisPostRequest {
    /**
     * 
     * @type {CreditRefundRequest}
     * @memberof UserRefundApiApiRefundsCreditRefundWhoisPost
     */
    readonly creditRefundRequest?: CreditRefundRequest
}

/**
 * Request parameters for apiRefundsProcessRefundRefundIdPost operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiRefundsProcessRefundRefundIdPostRequest
 */
export interface UserRefundApiApiRefundsProcessRefundRefundIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof UserRefundApiApiRefundsProcessRefundRefundIdPost
     */
    readonly refundId: number

    /**
     * 
     * @type {ProcessUserRefundRequest}
     * @memberof UserRefundApiApiRefundsProcessRefundRefundIdPost
     */
    readonly processUserRefundRequest?: ProcessUserRefundRequest
}

/**
 * Request parameters for apiRefundsStatusRefundIdGet operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiRefundsStatusRefundIdGetRequest
 */
export interface UserRefundApiApiRefundsStatusRefundIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserRefundApiApiRefundsStatusRefundIdGet
     */
    readonly refundId: number
}

/**
 * Request parameters for apiUserRefundOptionsGet operation in UserRefundApi.
 * @export
 * @interface UserRefundApiApiUserRefundOptionsGetRequest
 */
export interface UserRefundApiApiUserRefundOptionsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserRefundApiApiUserRefundOptionsGet
     */
    readonly userId?: number
}

/**
* 
* @summary current user requesting credit refund into his bank account (Auth)
* @param {UserRefundApiApiCreditRefundRequestPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiCreditRefundRequestPost(requestParameters: UserRefundApiApiCreditRefundRequestPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiCreditRefundRequestPostAxiosParamCreator(requestParameters.creditRefundRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:ProcessRefundRequest)
* @param {UserRefundApiApiOperatorUserRefundsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiOperatorUserRefundsGet(requestParameters: UserRefundApiApiOperatorUserRefundsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiOperatorUserRefundsGetAxiosParamCreator(requestParameters.from, requestParameters.to, requestParameters.status, requestParameters.searchTerm, requestParameters.onlyManualRefunds, requestParameters.page, requestParameters.pageSize, options, configuration);
    const request: () => AxiosPromise<UserRefundRequestViewPagedResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:RefundAsCredit)
* @param {UserRefundApiApiRefundsAsCreditCancelRefundTokenPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiRefundsAsCreditCancelRefundTokenPut(requestParameters: UserRefundApiApiRefundsAsCreditCancelRefundTokenPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiRefundsAsCreditCancelRefundTokenPutAxiosParamCreator(requestParameters.refundToken, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary user can request his refund amount to be added as user credit in his account (Auth policies: auth:RefundAsCredit)
* @param {UserRefundApiApiRefundsAsCreditUserUserIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiRefundsAsCreditUserUserIdPost(requestParameters: UserRefundApiApiRefundsAsCreditUserUserIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiRefundsAsCreditUserUserIdPostAxiosParamCreator(requestParameters.userId, requestParameters.refundAsCreditRequest, options, configuration);
    const request: () => AxiosPromise<RefundAsCreditResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary cancel request of credit refund by admin (Auth policies: auth:CancelCreditRefundRequest)
* @param {UserRefundApiApiRefundsCancelCreditRefundRefundIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiRefundsCancelCreditRefundRefundIdDelete(requestParameters: UserRefundApiApiRefundsCancelCreditRefundRefundIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiRefundsCancelCreditRefundRefundIdDeleteAxiosParamCreator(requestParameters.refundId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth)
* @param {UserRefundApiApiRefundsCreditRefundIdAcceptPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiRefundsCreditRefundIdAcceptPost(requestParameters: UserRefundApiApiRefundsCreditRefundIdAcceptPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiRefundsCreditRefundIdAcceptPostAxiosParamCreator(requestParameters.id, requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth)
* @param {UserRefundApiApiRefundsCreditRefundManualGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiRefundsCreditRefundManualGet(requestParameters: UserRefundApiApiRefundsCreditRefundManualGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiRefundsCreditRefundManualGetAxiosParamCreator(requestParameters.from, requestParameters.to, options, configuration);
    const request: () => AxiosPromise<Array<AdminManualRefund>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary current user requesting credit refund into his bank account (Auth)
* @param {UserRefundApiApiRefundsCreditRefundPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiRefundsCreditRefundPost(requestParameters: UserRefundApiApiRefundsCreditRefundPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiRefundsCreditRefundPostAxiosParamCreator(requestParameters.creditRefundRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary retry request of credit refund by admin (Auth policies: auth:RetryCreditRefundRequest)
* @param {UserRefundApiApiRefundsCreditRefundRefundIdRetryPatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiRefundsCreditRefundRefundIdRetryPatch(requestParameters: UserRefundApiApiRefundsCreditRefundRefundIdRetryPatchRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiRefundsCreditRefundRefundIdRetryPatchAxiosParamCreator(requestParameters.refundId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary retry request of credit refund by admin (Auth policies: auth:GetRefundCreditStatus)
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiRefundsCreditRefundUpdateStatusesPost(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiRefundsCreditRefundUpdateStatusesPostAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary cancel request of credit refund by admin (Auth policies: auth:CancelCreditRefundRequest)
* @param {UserRefundApiApiRefundsCreditRefundWhoisIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiRefundsCreditRefundWhoisIdDelete(requestParameters: UserRefundApiApiRefundsCreditRefundWhoisIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiRefundsCreditRefundWhoisIdDeleteAxiosParamCreator(requestParameters.whoisId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth)
* @param {UserRefundApiApiRefundsCreditRefundWhoisPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiRefundsCreditRefundWhoisPost(requestParameters: UserRefundApiApiRefundsCreditRefundWhoisPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiRefundsCreditRefundWhoisPostAxiosParamCreator(requestParameters.creditRefundRequest, options, configuration);
    const request: () => AxiosPromise<RefundWhoisResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary operator either approves or disapproves a refund request (Auth policies: auth:ProcessRefundRequest)
* @param {UserRefundApiApiRefundsProcessRefundRefundIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiRefundsProcessRefundRefundIdPost(requestParameters: UserRefundApiApiRefundsProcessRefundRefundIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiRefundsProcessRefundRefundIdPostAxiosParamCreator(requestParameters.refundId, requestParameters.processUserRefundRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth)
* @param {UserRefundApiApiRefundsStatusRefundIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiRefundsStatusRefundIdGet(requestParameters: UserRefundApiApiRefundsStatusRefundIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiRefundsStatusRefundIdGetAxiosParamCreator(requestParameters.refundId, options, configuration);
    const request: () => AxiosPromise<RefundStatusResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth)
* @param {UserRefundApiApiUserRefundOptionsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserRefundApiApiUserRefundOptionsGet(requestParameters: UserRefundApiApiUserRefundOptionsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserRefundApiApiUserRefundOptionsGetAxiosParamCreator(requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<UserRefundOptionsResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
